export const parseTenant = () => {
  const { hostname } = location;

  if (hostname === "localhost") {
    return "demo";
  }

  const splitted = hostname.split(".");
  if (splitted.length === 3) {
    return splitted[0];
  }

  return undefined;
};
